<template>
  <div class="flex-column-between">
        <div  style="padding: 17px 15px 0 15px;">
            <div class="text">帮扶情况</div>

        </div>
      <div class="flex-between-align" style="padding: 0 281px 29px 281px;">
        <div class="flex-between">
          <img :src="leftlogo" alt="" class="img" style="margin-right: 12px;">
          <div class="flex-column-space-between">
            <p class="helptext">正在帮扶（人）</p>
            <p class="helptotal">67</p>
          </div>
        </div>
        <div class="flex-between">
          <img :src="rightlogo" alt="" class="img" style="margin-right: 12px;">
          <div class="flex-column-space-between">
            <p  class="helptext">帮扶结束（人）</p>
            <p class="helptotal">67</p>
          </div>
        </div>
      </div>
  </div>  
  </template>
  
  <script>

  export default {
    components: {
      
    },
    data() {
      return {
        leftlogo: require('@/assets/pic/helping.png'),
        rightlogo:require('@/assets/pic/helpover.png')
      }
    }
  }
  </script>
  
  <style scoped>
.img{

width: 60px;
height: 80px;



  }
.text{
margin-top: 15px;
font-size: 22px;
font-weight: 500;
letter-spacing: 0px;
line-height: 31.86px;
color: rgba(51, 51, 51, 1);
}
.college-select {
width: 150px;
/* height: 35px; */
}
.helptext{

font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
line-height: 24px;
color: rgba(153, 153, 153, 1);


}
.helptotal{

font-size: 36px;
font-weight: 700;
letter-spacing: 0px;
line-height: 48px;
color: rgba(51, 51, 51, 1);


}
  </style>